import { ExecutionsUI } from 'features/executions'

import { useConversationalist } from '../hooks'

export function ResumeButton() {
	const conversationalist = useConversationalist()

	if (conversationalist) {
		return <ExecutionsUI.ConversationTogglers id={conversationalist.entityId} />
	}
}
